// components/LoadingSpinner.js
import React from 'react';

const LoadingSpinner = () => {
  return (
    <p className="text-gray-500 text-center mb-4">Loading...</p>
  );
};

export default LoadingSpinner;
